<template>
    <b-card>
        <b-card-header>DMT</b-card-header>
        <b-card-body>
            <b-row>
                <b-col>
                    <b-button title="" @click="addVisible = !addVisible">+ Lägg till</b-button>
                    <b-modal title="DMT" v-model="addVisible" size="xl">
                        <fuelchargeedit @saved="saved()"></fuelchargeedit>
                    </b-modal>
                </b-col>
                <b-col>
                    <b-input-group class="md-7" v-if="this.selectedrows.length > 0">
                        Urval: {{ GetSelectedIds().length }}
                        <b-button variant="danger" size="sm" @click="removeSelected">Ta bort</b-button>
                        &nbsp;
                        <b-button variant="secondary" size="sm" @click="recalcSelected"><b-icon-calculator /> Räkna
                            om</b-button>
                    </b-input-group>                    
                </b-col>
                <b-col v-if="recalcStatus">
                    <b-progress :value="recalcStatus.progress" :max="100" show-progress ></b-progress>
                    <!-- <label>{{recalcStatus.text }}</label> -->
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <queryviewlistdetail qvtype="fuelcharge" ref="blist" :selectable="true" v-on:rowclicked="onclick"
                        v-bind:currentkey="currId" v-on:currentkeychanged="oncurrentkeychanged"
                        v-on:selectionchanged="selectionChanged" :detailsvisible="myModal" title="Meddelandedetaljer"
                        :isBusy="isBusy">
                        <template v-slot:details>
                            <!-- <apimessagedetails :message="work" v-if="work"></apimessagedetails> -->
                        </template>
                    </queryviewlistdetail>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>
<script>
import fuelchargeedit from './fuelchargeedit.vue';
import queryviewlistdetail from './../queryview/queryviewlistdetail.vue';

import { Api } from "../../lib/api";
const api = new Api();

export default {
    name: 'fuelchargelist',
    components: { fuelchargeedit, queryviewlistdetail },
    data() {
        return {
            currId: null,
            myModal: null,
            addVisible: false,
            selectedrows: [],
            isBusy: false,
            recalcStatus:null,
        }
    },
    methods: {
        onclick() {

        },
        onchange(id) {
            this.setCurrent(id);
        },
        selectionChanged(sel) {
            this.selectedrows = sel;
        },
        GetSelectedIds() {
            return !this.selectedrows ? [] :
                this.selectedrows.map(x => x._key);
        },
        oncurrentkeychanged() {

        },
        saved() {
            top.location.reload();
        },
        recalcSelected() {
            var bd = this.GetSelectedIds();
            if (confirm(`Räkna om valda DMT?`)) {
                this.recalcStatus = null;
                api.post('/api/debit/recalcfuelcharges', bd).then(res => {
                    alert('Omräkning avslutad!');
                });
                this.checkRecalcStatus();
            }
        },
        checkRecalcStatus() {         
            api.get('/api/debit/getrecalcstatus').then(res=>{
                this.recalcStatus = res.data;
                if(!res.data.finished)
                    setTimeout(this.checkRecalcStatus, 200);
            });
        },
        removeSelected() {
            var bd = this.GetSelectedIds();
            if(confirm(`Ta bort ${bd.length} rader?`)) {
                api.delete('/api/debit/deletefuelcharges?ids='+bd.join()).then(res=>{
                    alert(res.data);
                    top.location.reload();
                });                
            }
        }
    },

}
</script>